// Utilities
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
import { lazy } from "react";
export const CustomRecurrenceDialogContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-customrecurrencedialogcontainer" */ "./CustomRecurrenceDialogContainer")).then((bundle)=>{
        return {
            default: bundle.CustomRecurrenceDialogContainer
        };
    });
export const LazyCustomRecurrenceDialogContainer = /*#__PURE__*/ lazy(CustomRecurrenceDialogContainerLazyLoader);
